import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

const initialState = {
  data: [],
  loading: false,
  errorMessage: "",
};

// get testimonials
export const fetchTestimonial = createAsyncThunk(
  `testimonial/fetchTestimonial`,
  async () => {
    const response = await api.get("info/testimonials/");
    // console.log("res", response.data);
    return response.data;
  }
);

const testimonialSlice = createSlice({
  name: "testimonials",
  initialState,
  reducers: {},

  extraReducers(builder) {
    builder
      .addCase(fetchTestimonial.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTestimonial.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.errorMessage = "";
      })
      .addCase(fetchTestimonial.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      });
  },
});

export default testimonialSlice.reducer;
